module.exports = __webpack_public_path__ + "img/img1.efc5ccd9.png";